var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitForm.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "max-w-4xl mx-auto" },
        [
          !_vm.submitted
            ? [
                _c(
                  "div",
                  { staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-6" },
                  [
                    _vm.hasError("checksum")
                      ? _c("p", { staticClass: "mt-1 text-red-600" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getErrorFor("checksum")) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("form-input", {
                      staticClass: "sm:col-span-2",
                      attrs: {
                        label: "Name",
                        required: true,
                        error: _vm.getErrorFor("name"),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-input", {
                      attrs: {
                        type: "email",
                        label: "Email",
                        required: true,
                        error: _vm.getErrorFor("email"),
                      },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-input", {
                      attrs: {
                        type: "number",
                        label: "Phone Number",
                        error: _vm.getErrorFor("phone"),
                      },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "phone", $$v)
                        },
                        expression: "form.phone",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-textarea", {
                      staticClass: "sm:col-span-2",
                      attrs: {
                        label: "Message",
                        rows: 8,
                        required: true,
                        error: _vm.getErrorFor("message"),
                      },
                      model: {
                        value: _vm.form.message,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "message", $$v)
                        },
                        expression: "form.message",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex justify-end" },
                  [
                    _c("form-button", { attrs: { type: "submit" } }, [
                      _vm._v("Submit"),
                    ]),
                  ],
                  1
                ),
              ]
            : _c("div", { staticClass: "Copy" }, [
                _vm.successMessage
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.successMessage) },
                    })
                  : _c("div", [
                      _c("p", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n                    Thank you, your enquiry has been submitted. We will contact you shortly for payment and delivery details.\n                "
                        ),
                      ]),
                    ]),
              ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }